import { AxTabbedBase } from '@theme/ax-tabbed-base';

/**
 * Tabbed product lists — Swiper-based.
 *
 * Renders product-card blocks inside per-tab carousels. All logic lives in
 * AxTabbedBase; override getSwiperConfig() or any method here for divergence.
 *
 * @extends {AxTabbedBase}
 */
class AxTabbedProductListsComponent extends AxTabbedBase {
  static bemPrefix = 'ax-tabbed-product-lists';
}

customElements.define('ax-tabbed-product-lists-component', AxTabbedProductListsComponent);
